// Module
var code = "<div v-if=\"['wireTransfer', 'boleto'].includes(payment.name)\" class=\"offlineInstructions\"> <cBoletoInstructions v-if=\"payment.name === 'boleto'\" :customer=\"customer\" :payment=\"payment\"/> <cWireTransferInstructions v-if=\"payment.name === 'wireTransfer'\" :order=\"order\" :payment=\"payment\" :theme=\"theme\" :url=\"url\"/> </div> ";
// Exports
export default code;